import { Component, Input } from '@angular/core';

import { Customer } from 'src/app/models/customer/Customer';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-customer-avatar',
  templateUrl: './customer-avatar.component.html',
  styleUrls: ['./customer-avatar.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS]
})
export class CustomerAvatarComponent {
  @Input({ required: true }) customer!: Customer;

  get userAvatarLabel(): string {
    return this.customer.name.substring(0, 2).toUpperCase();
  }
}
